// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2-Zdh","header":"Messages_header__3QiJd"};